/**
 * Converts a camelCase or PascalCase field name into a human-readable label.
 * E.g. "SpotPrice" → "Spot Price", "ForwardPoints" → "Forward Points",
 * "Grouping1" → "Grouping 1", "NotionalAmountCurrency2" → "Notional Amount Currency 2".
 */
export function humanizeFieldName(field: string): string {
  return field
    .replace(/([a-z])([A-Z])/g, '$1 $2')   // camelCase boundary
    .replace(/([A-Z]+)([A-Z][a-z])/g, '$1 $2') // consecutive caps
    .replace(/(\D)(\d)/g, '$1 $2');           // letter-digit boundary
}
